import { Skeleton } from '@welbe/web-design-system';
import { Column, Row, Wrapper } from './Loading.styles';

export const Loading = (): JSX.Element => {
	return (
		<Wrapper>
			<Column>
				<Skeleton width="200px" height="20px" />
				<Row>
					<Skeleton width="20px" height="20px" />
					<Skeleton width="15px" height="20px" />
					<Skeleton width="200px" height="20px" />
				</Row>
			</Column>
			<Column>
				<Skeleton width="150px" height="20px" />
				<Skeleton width="100%" height="38px" />
			</Column>
			<Skeleton width="100%" height="45px" />
			<Skeleton width="100%" height="400px" />
		</Wrapper>
	);
};
